angular.module('core')
  .factory('uidFactory', [function() {

    var num = 0;

    var create = function() {
      var id = num++;

      return String(id);
    };

    return {
      create: create
    };
  }]);